import React, {Fragment} from "react";
import {Link} from "react-router-dom";

export default function MenuBarTop({
                                       user,
                                       isRuoloAdmin,
                                       isRuoloSegreteria,
                                       numRichiedenti,
                                       numCertificati,
                                       handleLogout,
                                   }) {


    return (
        <div className="row barratop">
            <div className="col-md-6">
                <div className="p-2">
                    <b><i className="fa-solid fa-phone ns-icon-link"/> TEL.</b> 011-5629881 | <b><i
                    className="fa-solid fa-envelope ns-icon-link"/> EMAIL</b> info@registrofiat.it
                </div>
            </div>
            <div className="col-md-6 text-end ns-utente-info">
                {
                    user ? (
                        <div>
                            {
                                isRuoloAdmin() || isRuoloSegreteria() ?
                                    <Fragment>
                                        <Link to={"/list-nuovi-soci"}>
                                            <i className="fas fa-user-plus pe-4 ns-icon-link"> <span
                                                className="badge badge-important">{numRichiedenti}</span></i>
                                        </Link>
                                        <Link to={"/list-certificati"}>
                                            <i className="fas fa-car pe-4 ns-icon-link"> <span
                                                className="badge badge-important">{numCertificati}</span></i>
                                        </Link>
                                    </Fragment>
                                    : ''
                            }
                            <span><i className="fas fa-user-lock"/>
                                {
                                    ` ${user.nome}`
                                }
                                    </span>
                            <Link to="/" className="btn btn-dark" onClick={() => handleLogout()}>
                                <i className="fa-solid fa-right-from-bracket"/> Esci
                            </Link>
                        </div>) : <div/>
                }
            </div>
        </div>
    );
}